import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SystemTable } from '../interfaces/system-table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConnectServerService } from '../../../services/connect-server.service';
import { Connect } from '../../../classes/connect';
import { ApiResponse } from '../../../interfaces/api-response';

@Component({
  selector: 'app-customer-table',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatTooltipModule
  ],
  templateUrl: './customer-table.component.html',
  styleUrl: './customer-table.component.scss'
})
export class CustomerTableComponent {

  displayedColumns: string[] = ['user', 'title', 'status', 'owner', 'installer'];
  dataSource = new MatTableDataSource<SystemTable>([]);

  itemsPerPage: number = 100;
  currentPageIndex: number = 1;
  totalResults: number = 0;
  lastPage: number = 0;
  groupbyuser: number = 0;

  constructor(private router: Router, private connectServerService: ConnectServerService) { }

  ngOnInit(): void {
    this.getSystemList();
  }

  showUser(index: number): boolean {
    if (index === 0) return true;

    const current = this.dataSource.data[index].user?.id;
    const previous = this.dataSource.data[index - 1].user?.id;

    return current !== previous;
  }

  showLine(index: number): boolean {
    if (index + 1 >= this.dataSource.data.length) return true;

    const next = this.dataSource.data[index + 1].user.id;
    const current = this.dataSource.data[index].user.id;

    return current !== next;
  }

  getSystemList() {
    this.connectServerService.getRequest(Connect.urlServerLaraApi, 'system/systemsListWeCare', {
      groupbyuser: this.groupbyuser, itemsPerPage: this.itemsPerPage, currentPageIndex: this.currentPageIndex,
      type_search: 1})
      .subscribe((val: ApiResponse<any>) => {
      if (val.data) {
        this.lastPage = val.data.pagination.lastPage;
        this.totalResults = val.data.pagination.total;
        this.dataSource.data = val.data.systemsList;
      }
    })
  }

  prevPage() {
    if (this.currentPageIndex > 0) {
      this.currentPageIndex -= 1;
      this.getSystemList();
    }
  }

  nextPage() {
    if (this.currentPageIndex+1 < this.lastPage) {
      this.currentPageIndex += 1;
      this.getSystemList();
    }
  }

  goToSystem(row: {system: {id: number, path: string},  user: any}) {
    // console.log(row);
    this.router.navigate([row.system.path, row.system.id ]);
  }

}
